import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { Building, Calendar } from 'lucide-react';

const AuctionDatesPage = () => {
  const [auctionHouses, setAuctionHouses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuctionHouses();
  }, []);

  const loadAuctionHouses = async () => {
    try {
      const response = await api.getAuctionHouses();
      setAuctionHouses(response.data);
    } catch (error) {
      console.error('Error loading auction houses:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'TBA';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  return (
    <div className="min-h-screen py-8" data-testid="auction-dates-page">
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-8">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 font-heading">
            UK Auction Houses
          </h1>
          <p className="text-base md:text-lg text-slate-600">
            Complete list of {auctionHouses.length} UK auction houses and their next auction dates
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <p className="text-slate-600">Loading auction houses...</p>
          </div>
        ) : (
          <div className="bg-white border border-slate-200 rounded-sm">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-slate-50 border-b border-slate-200">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-medium">Auction House</th>
                    <th className="px-6 py-4 text-left text-sm font-medium">Next Auction</th>
                    <th className="px-6 py-4 text-left text-sm font-medium">Last Scraped</th>
                    <th className="px-6 py-4 text-left text-sm font-medium">Website</th>
                  </tr>
                </thead>
                <tbody>
                  {auctionHouses.map((house, idx) => (
                    <tr 
                      key={house.auction_house_id} 
                      className="border-b border-slate-100 last:border-0 hover:bg-slate-50"
                      data-testid={`auction-house-row-${idx}`}
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <Building className="h-5 w-5 text-[#F5A623]" />
                          <span className="font-medium">{house.name}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          <Calendar className="h-4 w-4 text-slate-600" />
                          <span className="text-sm">{formatDate(house.next_auction_date)}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-slate-600">
                        {formatDate(house.last_scraped)}
                      </td>
                      <td className="px-6 py-4">
                        {house.url && (
                          <a 
                            href={house.url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-sm text-blue-600 hover:underline"
                            data-testid={`auction-house-link-${idx}`}
                          >
                            Visit Website
                          </a>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuctionDatesPage;